import ReceivePartsForm from '../ReceivePartsForm'
import useCompleteTransactionHandler from 'views/reports/effects/complete-transaction'
import { getRefetchTransactionQueries } from 'views/reports/utils'
import { Transaction } from 'graphql'

export const refetchQueries = getRefetchTransactionQueries()

export type ReceivingPartsProps = {
  closeForm: () => void,
  transaction: Transaction,
}

export default function ReceiveParts( { closeForm, transaction }: ReceivingPartsProps ) {
	const completeTransaction = useCompleteTransactionHandler( { refetchQueries } )

	return (
		<div className="scrollModalBody">
			<ReceivePartsForm
				closeForm={closeForm}
				completeTransaction={completeTransaction}
				transaction={transaction}
			/>
		</div>
	)
}
